import axios from "axios";
import { buildHeaders } from "@/services/_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}crm/`;

const entityPath = (entityType, entityId) =>
  `${API_URL}${entityType}/${entityId}`;

export default {
  getActivities(entityType, entityId) {
    return axios.get(`${entityPath(entityType, entityId)}/engagement/activities`, {
      headers: buildHeaders(),
    });
  },

  getNotes(entityType, entityId) {
    return axios.get(`${entityPath(entityType, entityId)}/notes`, {
      headers: buildHeaders(),
    });
  },

  createNote(entityType, entityId, data) {
    return axios.post(`${entityPath(entityType, entityId)}/notes`, data, {
      headers: buildHeaders(),
    });
  },

  updateNote(entityType, entityId, noteId, data) {
    return axios.put(`${entityPath(entityType, entityId)}/notes/${noteId}`, data, {
      headers: buildHeaders(),
    });
  },

  deleteNote(entityType, entityId, noteId) {
    return axios.delete(`${entityPath(entityType, entityId)}/notes/${noteId}`, {
      headers: buildHeaders(),
    });
  },

  getCalls(entityType, entityId) {
    return axios.get(`${entityPath(entityType, entityId)}/calls`, {
      headers: buildHeaders(),
    });
  },

  createCall(entityType, entityId, data) {
    return axios.post(`${entityPath(entityType, entityId)}/calls`, data, {
      headers: buildHeaders(),
    });
  },

  updateCall(entityType, entityId, callId, data) {
    return axios.put(`${entityPath(entityType, entityId)}/calls/${callId}`, data, {
      headers: buildHeaders(),
    });
  },

  deleteCall(entityType, entityId, callId) {
    return axios.delete(`${entityPath(entityType, entityId)}/calls/${callId}`, {
      headers: buildHeaders(),
    });
  },

  getFiles(entityType, entityId) {
    return axios.get(`${entityPath(entityType, entityId)}/files`, {
      headers: buildHeaders(),
    });
  },

  uploadFile(entityType, entityId, file) {
    const data = new FormData();
    data.append("file", file);

    return axios.post(`${entityPath(entityType, entityId)}/files`, data, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },

  downloadFile(entityType, entityId, fileId) {
    return axios.get(`${entityPath(entityType, entityId)}/files/${fileId}/download`, {
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  deleteFile(entityType, entityId, fileId) {
    return axios.delete(`${entityPath(entityType, entityId)}/files/${fileId}`, {
      headers: buildHeaders(),
    });
  },

  getEmails(entityType, entityId) {
    return axios.get(`${entityPath(entityType, entityId)}/emails`, {
      headers: buildHeaders(),
    });
  },

  sendEmail(entityType, entityId, data) {
    return axios.post(`${entityPath(entityType, entityId)}/emails`, data, {
      headers: buildHeaders(),
    });
  },
};
